// extracted by mini-css-extract-plugin
export var button = "_o0-2";
export var card = "_o0-0";
export var closeButtonContainer = "_o0-3";
export var iconContainer = "_o0-1";